import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.accountRegistrationList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.accountRegistrationList.error;
export const registrationListDataResponse = (state: RootState) =>
  state.accountRegistrationList.registrationListResponse;
